import { PaginatedQueryParams } from './api'
import { OrderingField } from './utility'

export enum ContactSourceType {
  Curve = 'curve_hero',
  Denticon = 'denticon',
  Dentrix = 'dentrix',
  DentrixAscend = 'dentrix_ascend',
  DentrixG7 = 'dentrix_g7',
  DentrixEnterprise = 'dentrix_enterprise',
  Eaglesoft = 'eaglesoft',
  Extensions = 'extensions',
  OpenDental = 'open_dental',
  Pbxes = 'pbxes',
  Unknown = 'unknown',
}

export enum ContactSourceProvider {
  Kolla = 'kolla',
  Mango = 'mango',
}

export interface ContactSource {
  id: number
  name: string
  source: ContactSourceType
  provider: ContactSourceProvider
  created_at: string
  updated_at: string
}

export enum ContactGender {
  Female = 'female',
  Male = 'male',
  NonBinary = 'non_binary',
  Other = 'other',
}
export enum ContactType {
  Patient = 'patient',
  Employee = 'employee',
  Vendor = 'vendor',
  Other = 'other',
}

export interface ContactPhoneNumber {
  id: number
  label?: string
  number?: string
  created_at: string
  updated_at: string
}

export interface Contact {
  id: number
  contact_source_id: number
  date_of_birth?: string
  family_name: string
  gender?: ContactGender
  given_name: string
  phone_numbers?: ContactPhoneNumber[]
  primary_phone_number?: ContactPhoneNumber
  type: ContactType
  created_at: string
  updated_at: string
}

/**
 * @description Represents a paginated Mango API response for a list of contacts.
 * @field contact_source_ids - A comma-separated list of contact source IDs to filter by.
 * @field pbx_id - The ID of the PBX to filter by.
 * @field ordering - The field to order the results by.  Prefix with "-" to reverse the order.
 * @field search - A search term to filter the results by.
 */
export interface ContactsQueryParams extends PaginatedQueryParams {
  contact_source_ids?: string
  pbx_id?: number
  ordering?: string
  search?: string
}

/**
 * @description Represents a paginated Mango API response for a list of contact sources.
 * @field ordering - The field to order the results by.  Prefix with "-" to reverse the order.
 * @field search - A search term to filter the results by.
 * @field pbx_id - The ID of the PBX to filter by.
 */
export interface ContactSourcesQueryParams extends PaginatedQueryParams {
  ordering?: OrderingField<ContactSource>
  search?: string
  pbx_id?: number
}
